module.exports = __webpack_public_path__ + "img/copy.390526c9.png";